<template>
    <div>
        <div class="container bg-light">
            <h1 class="bg-warning text-light rounded-pill">Over ons</h1>
            <h3 class="p-2 rounded-pill">Twiedalia Omroep Stichting</h3>
            <div class="text-left">
                <h4>
                    TOS biedt, als grootste en enige nieuwsorganisatie van Twiedalia, altijd en overal onafhankelijke en betrouwbare verslaggeving op het gebied van nieuws, vogelvoer, nestbouw en evenementen.</h4>
                <div class="d-flex flex-row justify-content-around flex-wrap">
                    <nieuws-medewerkers v-for="medewerker in medewerkers" v-bind:key="medewerker.id" :header="medewerker.header" :imgnaam="medewerker.imgnaam" :titel="medewerker.titel" :tekst1="medewerker.tekst1" :tekst2="medewerker.tekst2">
                    </nieuws-medewerkers>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import NieuwsMedewerkers from '@/components/NieuwsMedewerkers.vue'

    export default {
        name: 'overons',
        components: {
            NieuwsMedewerkers
        },
        data() {
            return {
                medewerkers: {
                    1: {
                        header: "Amber",
                        imgnaam: "dbamber.png",
                        titel: "Amber Star is onze nieuwslezeres",
                        tekst1: "Onze Amber is opgeleid als journalist en heeft al menig nieuwsitem verslagen. Zij is het gezicht van TOS.",
                        tekst2: "Iedereen is weg van Amber."
                    },
                    2: {
                        header: "Piep",
                        imgnaam: "dbpiep.png",
                        titel: "Piep Kuiken is onze on-the-go reporter",
                        tekst1: "Onze Piep is bekend van zijn vele onthullingen zoals de vogelvoer affaire, de vogelvoer fraude en de vogelvoer besmettingen.",
                        tekst2: " Piep bijt zijn snavel er in vast en laat niet los totdat het onderste nest-takje boven is gekomen."
                    },
                    3: {
                        header: "Zonnestraaltje",
                        imgnaam: "dbzonnestraal.png",
                        titel: "Zonnestraaltje Pietersen is ons Zonnestraaltje",
                        tekst1: "Zonnestraaltje presenteert het weer. Zij is onze positieve weersvrouw die zelfs van een regenachtige dag nog iets vrolijks weet te maken.",
                        tekst2: "Zonnestraaltje doet het weer en weer en weer en nog een keer weer."
                    },
                    4: {
                        header: "Scarlett",
                        imgnaam: "dbscarlett.png",
                        titel: "Scarlett Johansdottir is onze toevallige voorbijganger die we altijd interviewen",
                        tekst1: "In de naam Scarlett zit het woord alert. En alert is hij, het lijkt wel of overal waar wat gebeurt, Scarlett toevallig aanwezig is. Daarom interviewen wij hem graag.",
                        tekst2: "Ook is 'tastcel' een anagram van Scarlett. Toeval? Wij denken van niet!"
                    },
                }
            }
        },

    }
</script>
<style scoped>
    h3 {
        background-color: lightblue;
        padding: 3px;
    }
</style>
